import { sortBy } from 'lodash';

export interface ServiceUsagesGroupLike<T> {
  readonly index: number;
  readonly serviceUsages: readonly T[];
}

export const flattenServiceUsagesGroups = <T>(
  groups: readonly ServiceUsagesGroupLike<T>[] | null | undefined,
): readonly T[] | null | undefined => {
  if (!groups) {
    return groups;
  }

  return sortBy(groups, 'index').flatMap((group) =>
    sortBy(
      group.serviceUsages,
      (usage) => (usage as Readonly<{ index?: number }>).index ?? 0,
    ),
  );
};
